import {StyledHeaderContainer} from './style'
import {BreadCrumbs} from '@/components/commons/bread-crumbs/BreadCrumbs'
import {GlobalSearch} from '@/components/commons/global-search/GlobalSearch'
import {NotificationButton} from '@/features/notifications/components/notification-button/NotificationButton'
import {AccountMenu} from '@/features/account/components/account-menu/AccountMenu'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {NotificationsProvider} from '@/features/notifications/components/notifications-provider/NotificationsProvider'
import {useAuthStore, usePermissions} from '@/features/auth/store/store'
import {ExportsToggle} from '@/features/exports/components/exports-toggle/ExportsToggle'
import {useImpersonationExpiryTimer} from '@/features/auth/components/impersonation-expiry-timer/useImpersonationExpiryTimer'

export const Header = () => {
    const user = useAuthStore(state => state.user)
    const permissions = usePermissions()
    // Mounted here because the header is on every authenticated route, so the timer follows the operator around.
    useImpersonationExpiryTimer()
    return (
        <>
            <StyledHeaderContainer>
                <BreadCrumbs />
                {permissions?.patients.read && <GlobalSearch />}
                <Flexbox gap={2} align="center">
                    <ExportsToggle />
                    {user?.id ? (
                        <NotificationsProvider userId={user.id}>
                            <NotificationButton />
                        </NotificationsProvider>
                    ) : (
                        <NotificationButton />
                    )}
                    <AccountMenu />
                </Flexbox>
            </StyledHeaderContainer>
        </>
    )
}
